
export enum Language {
  English = 'English',
  Tamil = 'Tamil',
  Sinhala = 'Sinhala'
}

export enum Gender {
  Male = 'Male',
  Female = 'Female',
  Other = 'Other'
}

export interface UserData {
  name: string;
  gender: Gender | ''; // Allow empty string for initial state
  birthDate: string;
  birthTime: string;
  birthLocation: string;
  language: Language | ''; // Allow empty string for initial state
}

export interface ChartDataModel {
  labels: {
    rasi: string;
    navamsa: string;
  };
  rasi: Record<string, string[]>;
  navamsa: Record<string, string[]>;
}

export interface Message {
  id: string;
  role: 'user' | 'model';
  text: string;
  timestamp: Date;
  isError?: boolean;
  chartData?: ChartDataModel;
}

export interface ChatState {
  messages: Message[];
  isLoading: boolean;
  isInitialized: boolean;
}
